import { socials } from "../data/site";

const Contact = () => {
  const socialLinks = socials.filter((s) => s.type !== "Email");
  const email = socials.find((s) => s.type === "Email");

  return (
    <section className="section contact" id="contact">
      <div className="wrap">
        <div className="contact-eyebrow">
          <span className="sec-num">★</span>
          <span className="sec-kicker">Contact</span>
        </div>
        <h2 className="contact-h2">
          Let's build something — <em>or swap travel stories.</em>
        </h2>
        {email && (
          <a className="contact-mail" href={email.link}>
            {email.handle}
          </a>
        )}
        <ul className="social-list">
          {socialLinks.map((s) => (
            <li key={s.type}>
              <a href={s.link} target="_blank" rel="noreferrer">
                <span className="soc-type">{s.type}</span>
                <span className="soc-handle">{s.handle}</span>
              </a>
            </li>
          ))}
        </ul>
        <div className="foot-rule" />
        <div className="foot-row">
          <span>© {new Date().getFullYear()} Megholova</span>
          <span>Code by day · horizons by passport</span>
        </div>
      </div>
    </section>
  );
};

export default Contact;
